/*
 * Copyright (C) 2017 BossieTech Co.,Ltd. All Rights Reserved.
 * Creator  :   Alfred
 * Date     :   2018/10/22
 */
import request from '@/utils/request'

// 登录获取token
// export function login(username, password, solution) {
//   const data = {
//     username,
//     password,
//     solution
//   }
//   return request({
//     url: '/authorize/accesstoken',
//     method: 'post',
//     data
//   })
// }
// 登录获取token
export function login(userInfo) {
  const {username, password, solution, state, captchId, params} = userInfo
  const data = {
    captchId,
    state,
    username,
    password: password || '_0_MISSING_0_',
    // grant_type: 'password',
    client_id: 'web',
    // client_secret: 'secret',
    // scope: 'openid offline_access non-designer',
    sid: solution,
    eid: 1
  }
  const formData = new FormData()
  Object.keys(data).forEach((key) => {
    formData.append(key, data[key])
  })
  return request({
    url: '/account/login',
    method: 'post',
    data: formData,
    params,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 刷新token
export function refreshToken(sid, refresh_token) {
  const data = {
    // grant_type: 'refresh_token',
    client_id: 'web',
    // client_secret: 'secret',
    refresh_token,
    sid
  }
  const formData = new FormData()
  Object.keys(data).forEach((key) => {
    formData.append(key, data[key])
  })
  return request({
    url: '/account/login/refresh',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 获取账套
export function getSolutions() {
  return request({
    url: '/solutions',
    method: 'get'
  })
}
// 登出
export function logout() {
  return request({
    url: '/account/logout',
    method: 'post'
  })
}
// 获取用户信息
export function getInfo(id) {
  return request({
    url: `/users/${id}`,
    method: 'get'
  })
}
// 获取用户头像
export function getUserAvatar(id) {
  return request({
    url: `/users/${id}/avatar`,
    method: 'get',
    responseType: 'blob'
  })
}
// 获取用户模板集合,以分类树的形式展现
export function getTemplateCategorys(id) {
  return request({
    url: `/users/${id}/templates`,
    method: 'get'
  })
}

// 更新用户头像
export function updateUserAvatar(id, data) {
  return request({
    url: `/users/${id}/avatar`,
    method: 'put',
    data,
    config: {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
  })
}

// 获取系统当前设置
export function getSystemSettings(id) {
  return request({
    url: `/solutions/${id}/setting`,
    method: 'get'
  })
}

// 获取工作系统当前设置
export function getWorkStationSettings() {
  return request({
    url: '/systemsettings/work',
    method: 'get'
  })
}

// 获取工作系统当前LOGO
export function getWorkStationLogo(sid) {
  return request({
    url: `/solutions/${sid}/images?key=4`,
    method: 'get'
  })
}

// 普通用户更新自己的密码
export function updateUserPassword(id, oldPass, password) {
  const data = [
    {
      'from': oldPass,
      'value': password,
      'path': '/Password',
      'op': 'replace'
    }
  ]
  return request({
    url: `/users/${id}/password`,
    method: 'patch',
    data
  })
}
// 普通用户更新自己的昵称
export function updateUserName(id, name) {
  const data = [
    {
      'value': name,
      'path': '/Name',
      'op': 'replace'
    }
  ]
  return request({
    url: `/users/${id}/name`,
    method: 'patch',
    data
  })
}

export function heartCheck() {
  return request({
    url: `/heart`,
    method: 'post'
  })
}

// 获取用户邮件信息
export function getUserEmail(id) {
  return request({
    url: `/users/${id}/email`,
    method: 'get'
  })
}
// 更新用户邮箱
export function updateUserEmail(id, data) {
  return request({
    url: `/users/${id}/email`,
    method: 'put',
    data
  })
}
// 使用系统邮箱向用户发送重置账户密码邮件
export function resetPwdMail(data, id = 0) {
  return request({
    url: `/email/${id}/resetpwd`,
    method: 'post',
    data
  })
}
// 重置用户密码
export function resetPwd(data) {
  return request({
    url: `/resetpwd`,
    method: 'post',
    data
  })
}
// 邮件账号连通性检查,用系统邮箱发送测试邮件
export function checkMail(id, data) {
  return request({
    url: `/email/${id}/connect`,
    method: 'post',
    data
  })
}

// 获取系统外部接口token
export function getOtherSetting(params) {
  return request({
    url: `/systemsettings/token`,
    method: 'get',
    params
  })
}

// 单点登录
export function loginProvider(params) {
  const data = {
    state: params.state,
    lid: params.lid,
    client_id: 'web',
    sid: params.sid,
    eid: 1
  }
  const formData = new FormData()
  Object.keys(data).forEach((key) => {
    formData.append(key, data[key])
  })
  return request({
    url: `/account/login/${params.lid}`,
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 第三方登录
export function thirdPartyLogin(params) {
  const newTypeMap = {
    wechat: 8,
    wechatwork: 16,
    dingTalk: 32,
    ldap: 64,
    rtxwechat: 128
  }
  const apiMap = {
    wechat: 'wechat',
    wechatwork: 'workwechat',
    dingTalk: 'dingtalk',
    ldap: 'ldap',
    rtxwechat: 'rtxwechat'
  }
  const data = {
    state: params.state,
    code: params.code,
    username: params.username,
    password: params.password,
    // grant_type: 'password',
    client_id: 'web',
    // client_secret: 'secret',
    // scope: 'openid offline_access non-designer',
    sid: params.sid,
    eid: newTypeMap[params.type]
  }
  const formData = new FormData()
  Object.keys(data).forEach((key) => {
    formData.append(key, data[key])
  })
  return request({
    url: `/account/login/${apiMap[params.type]}`,
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 获取登录控制信息
export function getThirdParty(id, type = 2) {
  const params = {
    type
  }
  return request({
    url: `/solutions/${id}/logins`,
    method: 'get',
    params
  })
}

// 验证密码安全策略
export function verifySecurity(data) {
  return request({
    url: `/systemsettings/verifysecurity`,
    method: 'post',
    data
  })
}

// 用户注册
export function register(data) {
  return request({
    url: `/users/register`,
    method: 'post',
    data
  })
}

// 用户账号激活
export function activation(data) {
  return request({
    url: `/users/activation`,
    method: 'post',
    data
  })
}

// 获取应用系统的设置信息时间戳，返回0个或多个信息
export function getTimestamps(id) {
  return request({
    url: `/solutions/${id}/timestamps`,
    method: 'get'
  })
}

// 获取匿名全局设置
export function getGlobalSetting(name) {
  const params = {
    name
  }
  return request({
    url: `/systemsettings/global`,
    method: 'get',
    params
  })
}

// 获取匿名登录信息并尝试登录
export function anonymousLogin(id, systemId) {
  const params = {systemId}
  return request({
    url: `/templateFills/${id}/token`,
    method: 'get',
    params
  })
}
